import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './global.css';
import reportWebVitals from './reportWebVitals';
import { createHashRouter, HashRouter, Route, RouterProvider, Routes } from 'react-router-dom';
import { Main } from './view/Main';
import { About } from './view/About';
import { ThemeProvider } from './components/ThemeProvider';

const router = createHashRouter([
  {
    path: "/",
    element: <Main />
  },
  {
    path: "/about",
    element: <About />
  }
], {
  basename: "/myself"
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider
      defaultTheme="system"
      attribute="class"
      enableSystem
      disableTransitionOnChange>
        <HashRouter>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </HashRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
